// import Slider from '@material-ui/lab/Slider';
import autobind from 'autobind-decorator';
import * as React from 'react';
import AvatarEditor from 'react-avatar-editor';
import { connect } from 'react-redux';
import { AnyAction, Dispatch } from 'redux';
import { InjectedFormProps, reduxForm } from 'redux-form';

import './restrict-image-dialog.scss';

import { KreoButton, KreoDialog, KreoDialogActions } from 'common/UIKit';
import { RESTRICT_AVATAR } from '../../../../constants/forms';
import { AccountActions } from '../../../../units/account/actions/creators';
import { State as ReduxState } from '../../../interfaces/state';

interface ReduxProps {
  file: File;
}

interface ReduxActions {
  close: () => void;
}

interface CustomProps extends ReduxProps, ReduxActions {
  onCrop: (image: any) => void;
}

interface Props extends InjectedFormProps<any, CustomProps>, CustomProps { }

interface State {
  scale: number;
}

export const RESTRICT_AVATAR_DIALOG_NAME = 'restrictAvatarDialog';

class RestrictImageDialogComponent extends React.Component<Props, State> {
  private avatarEditorColor: number[] = [0, 0, 0, 0.6];
  private editor: AvatarEditor;

  constructor(props: Props) {
    super(props);

    this.state = {
      scale: 1,
    };
  }

  public render(): JSX.Element {
    const { file } = this.props;

    return (
      <KreoDialog
        name={RESTRICT_AVATAR_DIALOG_NAME}
        title='Crop an avatar'
        onClose={this.onDialogClose}
      >
          {file ?
          <div className='restrict-image'>
              <AvatarEditor
                ref={this.setEditorRef}
                image={file}
                width={250}
                height={250}
                border={25}
                scale={this.state.scale}
                color={this.avatarEditorColor}
              />
              <div className='restrict-image__slider-container'>
                {/* <Slider
                  value={this.state.scale}
                  min={.5}
                  max={4}
                  onChange={this.onSliderChange}
                /> */}
              </div>
              <div className='restrict-image__action'>
                <KreoButton
                  key={2}
                  caption='Cancel'
                  onClick={this.props.close}
                  mode='ghost'
                  size='large'
                />
                <KreoButton
                  size='large'
                  key={1}
                  mode='submit'
                  caption='Crop'
                  onClick={this.onCrop}
                />
              </div>
            </div> : null
          }
      </KreoDialog>
    );
  }

  // @autobind
  // private onSliderChange(event: React.MouseEvent<HTMLElement>, value: number): void {
  //   event.preventDefault();
  //   this.setState({
  //     scale: value,
  //   });
  // }

  @autobind
  private onDialogClose(): void {
    this.props.reset();
    this.props.close();
    this.setState({
      scale: 1,
    });
  }

  @autobind
  private setEditorRef(editor: AvatarEditor): void {
    this.editor = editor;
  }

  @autobind
  private onCrop(): void {
    const canvas = this.editor.getImage();

    if (this.props.onCrop) {
      this.props.onCrop(canvas);
    }

    this.onDialogClose();
  }
}

const mapStateToProps = (state: ReduxState): ReduxProps => {
  return {
    file: state.account.restrictAvatarFile,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): ReduxActions => {
  return {
    close: () => {
      dispatch(KreoDialogActions.closeDialog(RESTRICT_AVATAR_DIALOG_NAME));
      dispatch(AccountActions.setAvatarFile(null));
    },
  };
};

const restrictImageDialogForm = reduxForm<any, CustomProps>({
  form: RESTRICT_AVATAR,
  destroyOnUnmount: true,
})(RestrictImageDialogComponent);
const connector = connect(mapStateToProps, mapDispatchToProps);

export const RestrictImageDialog = connector(restrictImageDialogForm);
